import { FC, useState } from 'react';
import { Box, Grid, Autocomplete, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCUIAutoCompleteInput, SCUIButton } from '../../../../atomic/atoms';
import { SCUIGeneralDrawerHeader } from '../../../../atomic/molecules';
import { EmailTemplateBuilderServiceQuery } from '../../../../services/query';
import Swal from 'sweetalert2';
import Helper from '../../../../utils/helper';
import { ETBED_SUB_NAME, etbCls } from '../../emailTemplateBuilder.classes';
import { sectionTypes } from '../../EmailTemplateBuilder.config';

interface IProps {
    onClose?: any;
    setSelectedSubSectionList?: any;
}
export const AddSubSectionNameDrawer: FC<IProps> = ({ onClose, setSelectedSubSectionList }) => {
    const { t } = useTranslation();
    const [findedSection, setFindedSection] = useState<any>();
    const [autocompleteData, setAutocompleteData] = useState<any>();
    const [selectedType, setSelectedType] = useState(2);

    const handleAddButton = () => {
        if (findedSection !== undefined) {
            let text = `[$${findedSection.key}]`;
            setSelectedSubSectionList(text);
        } else {
            Swal.fire('Lütfen bir alt alan seçiniz');
        }
    };

    const selectionHandleChange = (newValue: any) => {
        setFindedSection(newValue);
    };
    const handleSearch = (text: any) => {
        let countryCode = Helper.getCountryCodeFromCountryId();
        const parsedLanguageObject = JSON.parse(localStorage.getItem('languageObject') || '{}');

        let request = {
            type: selectedType,
            keyword: text,
            languageCode: parsedLanguageObject.value || parsedLanguageObject.languageCode || 'tr-TR',
            countryCode: countryCode,
            take: 100,
            skip: 1,
        };
        EmailTemplateBuilderServiceQuery.GetSectionData(request).then((res: any) => {
            setAutocompleteData(res.data);
        });
    };
    return (
        <form
            onSubmit={(e: any) => {
                e.preventDefault();
            }}
        >
            <div className={etbCls('emailTemplateAddSubsectionNameContainer', ETBED_SUB_NAME.shell)} style={{ padding: '1rem' }}>
                {
                    <Grid container spacing={1}>
                        <SCUIGeneralDrawerHeader
                            header={t('emailTemplateBuilder.addSubsectionName')}
                            onClose={onClose}
                        />
                        <Grid
                            className={ETBED_SUB_NAME.fieldSectionType}
                            style={{ paddingTop: '16px' }}
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <Autocomplete
                                className={ETBED_SUB_NAME.autocompleteSectionTypeRoot}
                                options={sectionTypes}
                                getOptionLabel={(option: any) => option.name}
                                value={sectionTypes.find((item: any) => item.id === selectedType) || null}
                                onChange={(_, newValue) => {
                                    setSelectedType(newValue?.id || 2);
                                    setFindedSection(undefined);
                                    setAutocompleteData([]);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        className={ETBED_SUB_NAME.inputAutocompleteSectionType}
                                        label={t('emailTemplateBuilder.sectionType')}
                                        size="small"
                                        fullWidth
                                    />
                                )}
                                disablePortal
                            />
                        </Grid>
                        <Grid
                            className={ETBED_SUB_NAME.fieldSectionSearch}
                            style={{ paddingTop: '16px' }}
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <Grid
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12,
                                }}
                            >
                                <Box className={ETBED_SUB_NAME.subsectionAutocompleteWrap}>
                                {
                                    <SCUIAutoCompleteInput
                                        list={autocompleteData || []}
                                        onChange={(event: any, newValue: any) => {
                                            selectionHandleChange(newValue);
                                        }}
                                        onChangeTextField={(e: any) => {
                                            if (e.target.value.length > 2) {
                                                handleSearch(e.target.value);
                                            }
                                        }}
                                        multiple={false}
                                        txtPlaceHolder={t('emailTemplateBuilder.addSubSection')}
                                        searchValue="key"
                                    />
                                }
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid
                            className={ETBED_SUB_NAME.spacerGrid}
                            container
                            spacing={1}
                            sx={{ minHeight: { xs: 250, lg: 450 }, paddingBottom: '1rem' }}
                        ></Grid>
                        <Grid
                            className={ETBED_SUB_NAME.actionsFooter}
                            style={{
                                position: 'absolute',
                                bottom: 0,
                                width: 380,
                                marginBottom: '20px',
                            }}
                        >
                            <SCUIButton
                                className={ETBED_SUB_NAME.inputButtonAdd}
                                text={t('general.add')}
                                type="primary"
                                sizeType="default"
                                buttonType="submit"
                                size={'s'}
                                fullwidth
                                onClick={handleAddButton}
                            />
                        </Grid>
                    </Grid>
                }
            </div>
        </form>
    );
};
